
import React, { forwardRef } from 'react';

const InputWithIcon = forwardRef(({ label, id, icon, error, ...props }, ref) => (
  <div className="mb-4">
    {label && (
      <label
        className="block text-gray-700 text-sm font-bold mb-2"
        htmlFor={id}
      >
        {label}
      </label>
    )}
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        {icon}
      </div>
      <input
        id={id}
        ref={ref}   // ✅ now ref is passed correctly
        {...props}
        className={`shadow-sm appearance-none border rounded-lg w-full py-3 px-4 pl-10 text-gray-700 leading-tight focus:outline-none focus:ring-2 ${
          error ? 'border-red-500 focus:ring-red-500' : 'focus:ring-blue-500'
        }`}
      />
    </div>
    {error && <p className="text-red-500 text-xs italic mt-1">{error}</p>}
  </div>
));

InputWithIcon.displayName = 'InputWithIcon'; // helpful for React DevTools

export default InputWithIcon;



// import React from 'react';

// const InputWithIcon = ({ label, id, icon, error, ...props }) => (
//   <div className="mb-4">
//     <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={id}>
//       {label}
//     </label>
//     <div className="relative">
//       <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//         {icon}
//       </div>
//       <input
//         id={id}
//         ref={ref}   // ✅ now the parent can call .focus()
//         {...props}
//         className={`shadow-sm appearance-none border rounded-lg w-full py-3 px-4 pl-10 text-gray-700 leading-tight focus:outline-none focus:ring-2 ${
//           error ? 'border-red-500 focus:ring-red-500' : 'focus:ring-blue-500'
//         }`}
//       />
//     </div>
//     {error && <p className="text-red-500 text-xs italic mt-1">{error}</p>}
//   </div>
// );

// export default InputWithIcon;
